import { Injectable } from '@angular/core';
import { SessionStorageService } from 'angular-web-storage';
import { Observable, Subject } from 'rxjs';
import { SharedSettingsService, Policy } from 'wtw-ui-components';
import { ClaimDetails, UploadDocuments } from '../../shared/models';


export const ClaimDetailsKey = 'ClaimDetails';
export const UploadDocumentsKey = 'UploadDocuments';
export const ClaimIdKey = 'ClaimId';
export const CustomerIdKey = 'customerId';
export const ClaimResumeFlag = 'isClaimResume';
export const AnswersToResumeKey = 'AnswersToResumeKey';
export const ApplicationPreviousURL = 'ApplicationPreviousURL';
export const AllQuestionsAnsweredKey = 'AllQuestionsAnswered';
export const UserPreferredLanguageID = 'UserPreferredLanguageID';
export const DisableNewClaimsKey = 'DisableNewClaims';
export const CurrentDocumentCountKey = 'CurrentDocumentCount';
export const ManageClaimsb2cSalesPortalEnabledKey = 'ManageClaimsb2cSalesPortalEnabled'
export const EnableCustomerIdentityB2CClaimsKey = 'EnableCustomerIdentityB2CClaims';
export const EmailIdKey = 'EmailId';

@Injectable({
  providedIn: 'root'
})
export class ClaimsSettingsService extends SharedSettingsService {

  private isLoading = new Subject<boolean>();

  constructor(sessionStorageService: SessionStorageService) {
    super(sessionStorageService);
  }

  /* Define Claims Application scoped Settings here, global settings on base. */

  public get currentDocumentCount(): number {
    return this.getValue<number>(CurrentDocumentCountKey);
  }

  public set currentDocumentCount(value: number) {
    this.setValue(CurrentDocumentCountKey, value);
  }

  // CustomerId
  public get customerId(): number {
    return this.getValue<number>(CustomerIdKey);
  }

  public set customerId(value: number) {
    this.setValue(CustomerIdKey, value);
  }

  // DisableNewClaimsKey
  public get disableNewClaims(): boolean {
    return this.getValue<boolean>(DisableNewClaimsKey);
  }

  public set disableNewClaims(value: boolean) {
    this.setValue(DisableNewClaimsKey, value);
  }


  // ClaimDetails
  public get claimDetails(): ClaimDetails {
    return this.getValue<ClaimDetails>(ClaimDetailsKey);
  }

  public set claimDetails(value: ClaimDetails) {
    this.setValue(ClaimDetailsKey, value);
  }

  // Selectd documents by user
  public get uploadDocuments(): UploadDocuments {
    return this.getValue<UploadDocuments>(UploadDocumentsKey);
  }

  public set uploadDocuments(value: UploadDocuments) {
    this.setValue(UploadDocumentsKey, value);
  }

  // Claim Id
  public get claimId(): number {
    return this.getValue<number>(ClaimIdKey);
  }

  public set claimId(value: number) {
    this.setValue(ClaimIdKey, value);
  }

  // Userpreferredlanguage Id
  public get userPreferredLanguageId(): number {
    return this.getValue<number>(UserPreferredLanguageID);
  }

  public set userPreferredLanguageId(value: number) {
    this.setValue(UserPreferredLanguageID, value);
  }

  public resetClaim() {
    this.claimDetails = null;
    this.uploadDocuments = null;
    this.answersToResume = null;
    this.allQuestionsAnswered = false;
  }

  //  Claim status
  public get isClaimResume(): boolean {
    return this.getValue<boolean>(ClaimResumeFlag);
  }

  public set isClaimResume(value: boolean) {
    this.setValue(ClaimResumeFlag, value);
  }

  public get answersToResume() {
    return this.getValue(AnswersToResumeKey);
  }

  public set answersToResume(value) {
    this.setValue(AnswersToResumeKey, value);
  }

  public get applicationPreviousURL(): string {
    return this.getValue(ApplicationPreviousURL);
  }

  public set applicationPreviousURL(value: string) {
    this.setValue(ApplicationPreviousURL, value);
  }

  public getGlobalLoader(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  public setGlobalLoader(value: boolean) {
    this.isLoading.next(value);
  }

  public get allQuestionsAnswered(): boolean {
    return this.getValue<boolean>(AllQuestionsAnsweredKey);
  }

  public set allQuestionsAnswered(value: boolean) {
    this.setValue(AllQuestionsAnsweredKey, value);
  }

  // EnableCustomerIdentityB2CClaimsKey
  public get enableCustomerIdentityB2CClaims(): boolean {
    return this.getValue<boolean>(EnableCustomerIdentityB2CClaimsKey);
  }

  public set enableCustomerIdentityB2CClaims(value: boolean) {
    this.setValue(EnableCustomerIdentityB2CClaimsKey, value);
  }

  // ManageClaimsb2cSalesPortalEnabledKey
  public get manageClaimsb2cSalesPortalEnabled(): boolean {
    return this.getValue<boolean>(ManageClaimsb2cSalesPortalEnabledKey);
  }

  public set manageClaimsb2cSalesPortalEnabled(value: boolean) {
    this.setValue(ManageClaimsb2cSalesPortalEnabledKey, value);
  }

}
